/*
https://www.facebook.com/
https://www.instagram.com/?hl=en
https://twitter.com/?lang=en

* Copyright (c) 2021. by N-Ach (Pvt) Ltd
*
* ╔═╗ ╔╗    ╔═══╗  ╔╗
* ║║╚╗║║    ║╔═╗║  ║║
* ║╔╗╚╝║    ║║ ║╠══╣╚═╗
* ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
* ║║ ║║║╚══╝║╔═╗║╚═╣║║║
* ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
*
* All rights reserved.
*
* This software is the confidential and proprietary information
* of N-Ach (Pvt) Ltd. ("Confidential Information"). You
* shall not disclose such Confidential Information and shall use
* it only in accordance with the terms of the license agreement
* you entered into with N-Ach (Pvt) Ltd.
*
*
* @Author Shalani Chethana
* @Date 18/03/2025
*/


import React from "react";
import { Container, Typography, Button ,Grid} from "@mui/material";
import ContactForm from "../components/contact/ContactForm";
import contactImg from "../assets/images/product/GraphicDesign AboutUs.png";
// import backgroundVideo from "../assets/videos/contactUs.mp4";
import ContactBtnDialog from "../components/contact/contactBtnDialog";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import Styles from "../components/contact/ContactForm.module.css";


export default function Contact() {
  return (
    <div>
      <div className={Styles.videoCompOuterBox}>
        <video autoPlay muted loop id="myVideo" className={Styles.videoComp}>
          <source src="https://n-ach-file-directory.sgp1.cdn.digitaloceanspaces.com/N_ACH_WEBSITE/N-ach_official_web/videos/contactUs.mp4" type="video/mp4" />
        </video>
        <div className={Styles.videoBackgroundBox}>
          <Typography variant='body1' className={Styles.videoBackgroundText}>We have put together a special combination of strategy,
            marketing, design, and digital expertise for your Need for Achievement, design, and digital expertise for your Need for Achievement
          </Typography>
          <ContactBtnDialog />

        </div>
      </div>
      <div>
        <div className={Styles.contactTopContentBox}>
          <Typography variant="h5" className={Styles.titelFirsttxt} >contact us</Typography>
          <Typography variant="h4" className={Styles.mainHeadertxt} >Get in touch with our team</Typography>
          <Typography variant="body1" className={Styles.contentBodytxt}> Contact our N-ACH sales team today to discover how our silicon-to-systems design solutions can streamline your design workflows, enhance productivity, and accelerate innovation. If you require further assistance, please leave us a message, and our team will respond promptly. We are committed to providing the flexibility and support necessary to drive success and unlock new opportunities for our clients.
          </Typography>

        </div>
        <div className={Styles.contactFormContentOuter}>
          <img src={contactImg} className={Styles.contactFormImg} />
          <ContactForm />
        </div>
        <div className={Styles.contactLocationOuters}>
          <div className={Styles.contactAddressSect}>
            <Typography variant="h4" className={Styles.mainHeadertxt} >Our Office</Typography>
            <div className={Styles.titelUnderLine}></div>
            <Typography variant="h5" className={Styles.contentBodytxt}>LET'S START SOMETHING NEW TOGETHER.</Typography>

            <Typography variant="h6" className={Styles.contactDetailsLable}><LinkedInIcon />LinkedIn</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="https://www.linkedin.com/company/n-ach/">https://www.linkedin.com/company/n-ach/</a></Typography>

            <Typography variant="h6" className={Styles.contactDetailsLable}><FacebookIcon/> Facebook</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="https://www.facebook.com/N.ACH.SOFTWARE.SOLUTIONS">https://www.facebook.com/N.ACH.SOFTWARE.SOLUTIONS</a></Typography>

            <Typography variant="h6" className={Styles.contactDetailsLable}><EmailIcon /> Email</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="mailto:info@n-ach.com">info@n-ach.com</a></Typography>
          
            <Typography variant="h6" className={Styles.contactDetailsLable}><ContactPhoneIcon/> Call Us</Typography>
            <Grid container spacing={2} className={Styles.footerGridContainer}>
              <Grid item xs={6} md={6} className={Styles.footerSection}>
                <Typography variant="h6" className={Styles.contactDetailsLableLitel}>Sri Lanka</Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+94716904907">+94 716904907</a></Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+94703259026">+94 703259026</a></Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+94112745031">+94 112745031</a></Typography>
              </Grid>
              <Grid item xs={6} md={6} className={Styles.footerSection}>
                <Typography variant="h6" className={Styles.contactDetailsLableLitel}>UAE</Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+971589832288">+971 589832288</a></Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+971586355200">+971 586355200</a></Typography>
                <Typography variant="body1" className={Styles.contactDetailsTxt} ><a href="tel:+97145510787">+971 45510787</a></Typography>
              </Grid>
            </Grid>

            
          </div>
          <div className={Styles.contactAddressMapSect}>
            <Typography variant="h6" className={Styles.contactDetailsLable}>Address Sri Lanka</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt}>185 High Level Rd,</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt}>Maharagama 10280</Typography>

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3961.38141427099!2d79.93023427499577!3d6.844796293153411!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae25164b12f5445%3A0x34f08dd34c2349d8!2sN-ACH%20(Pvt)%20Ltd!5e0!3m2!1sen!2slk!4v1741105506977!5m2!1sen!2slk" className={Styles.conatctFormMap} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>

            <Typography variant="h6" className={Styles.contactDetailsLable}>Address UAE</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt}>Block B, Office – B30-029,</Typography>
            <Typography variant="body1" className={Styles.contactDetailsTxt}>Research Technology and Innovation Park</Typography>

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d51894.97058147832!2d55.46492584100132!3d25.33052511476634!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3e5f5f5df14e533d%3A0x73cc61cd6d65a7e3!2sSharjah%20Research%20Technology%20and%20Innovation%20Park!5e0!3m2!1sen!2slk!4v1742803198459!5m2!1sen!2slk" className={Styles.conatctFormMap} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" ></iframe>
          </div>

        </div>

      </div>
    </div>
  );
}
